export const FontSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export type FontSize = (typeof FontSize)[keyof typeof FontSize];

export const FontWeight = {
  normal: 'normal',
  bold: 'bold',
} as const;

export type FontWeight = (typeof FontWeight)[keyof typeof FontWeight];

export const FontColor = {
  black: 'black',
  red: 'red',
  gray: 'gray',
} as const;

export type FontColor = (typeof FontColor)[keyof typeof FontColor];

export const FontAlign = {
  between: 'space-between',
  right: 'right',
} as const;

export type FontAlign = (typeof FontAlign)[keyof typeof FontAlign];
